@let chargingUserDetails = chargingUserDetails$ | async;
@if (chargingUserDetails) {
  @let cu = chargingUser();
  <div class="grid-cols">
    <div>
      <h3>Yderligere oplysninger</h3>
      @if (cu) {
        <table class="table">
          <tbody>
            <tr valign="top">
              <td>
                <strong>E-mail adresse:</strong>
              </td>
              <td class="align-right">
                <div>
                  {{ chargingUserDetails.emailAddress | emptyDash }}
                </div>
              </td>
            </tr>
            <tr valign="top">
              <td>
                <strong>Tlf.:</strong>
              </td>
              <td class="align-right">
                <div>+{{ chargingUserDetails.phoneCountryCode }} {{ chargingUserDetails.phoneNumber | emptyDash }}</div>
              </td>
            </tr>
            <tr valign="top">
              <td>
                <strong>Afdeling:</strong>
              </td>
              <td class="align-right">
                <div>
                  {{ chargingUserDetails.departmentName | emptyDash }}
                </div>
              </td>
            </tr>
            <tr valign="top">
              <td>
                <strong>Leveringsadresse:</strong>
              </td>
              <td class="align-right">
                <div>
                  {{ chargingUserDetails.idTagShippingAddress || chargingUserDetails.departmentAddress | emptyDash }}
                </div>
              </td>
            </tr>
            @if (!hasCompanyCar() && CompanyCarDetermined()) {
              @if (chargingUserDetails.bankRegistrationNumber) {
                <tr valign="top">
                  <td>
                    <strong>Reg. nr.:</strong>
                  </td>
                  <td class="align-right">
                    <div>
                      {{ chargingUserDetails.bankRegistrationNumber | emptyDash }}
                    </div>
                  </td>
                </tr>
              }
              @if (chargingUserDetails.bankAccountNumber) {
                <tr valign="top">
                  <td>
                    <strong>Kontonr.:</strong>
                  </td>
                  <td class="align-right">
                    <div>
                      {{ chargingUserDetails.bankAccountNumber | emptyDash }}
                    </div>
                  </td>
                </tr>
              }
              <tr valign="top">
                <td>
                  <strong>G4 Kontonr.:</strong>
                </td>
                <td class="align-right">
                  <div>
                    {{ chargingUserDetails.invoicingAccountNumber > 0 ? chargingUserDetails.invoicingAccountNumber : '-' }}
                  </div>
                </td>
              </tr>
            }
            @if (hasCompanyCar() && CompanyCarDetermined()) {
              <tr valign="top">
                <td>
                  <strong>G4 Aftalenr.:</strong>
                </td>
                <td class="align-right">
                  <div>
                    {{ chargingUserDetails.agreementNumber > 0 ? chargingUserDetails.agreementNumber : '-' }}
                  </div>
                </td>
              </tr>
            }
            <tr valign="top">
              <td>
                <strong>ID:</strong>
              </td>
              <td class="align-right">
                <div>
                  {{ chargingUserDetails.alias | emptyDash }}
                </div>
              </td>
            </tr>
            @if (!chargingUserDetails.alias) {
              <tr valign="top">
                <td>
                  <strong>Indtastede briknumre:</strong>
                </td>
                <td class="align-right">
                  <div>
                    {{ chargingUserDetails.printedIds | emptyDash }}
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
    <div>
      @if (idTags$ | async; as idTags) {
        <div class="id-tag-header">
          <h3>Tilknyttede brikker</h3>
          @if (idTags.length > 0) {
            <a class="text-right margin--top-m blue" [routerLink]="['/id-tags']" [queryParams]="idTagsQueryParams()">
              Brik-liste for disse brikker</a
            >
          }
        </div>
        @if (idTags.length === 0) {
          <em>Der er ingen tilknyttede brikker</em>
        }
        @if (idTags.length > 0) {
          <table class="table table--center-vert">
            <thead>
              <tr>
                <th class="align-left" style="max-width: 150px">Status</th>
                <th class="align-left">Printed ID</th>
                <th class="align-left">RFID</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (idTag of idTags; track idTag.idTagIdentifier) {
                <tr valign="top">
                  <td class="mat-chip">
                    @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Pending]) {
                      <svg [matTooltip]="'Afventer behandling'" class="icon-24">
                        <use href="assets/images/ok-icons-sprite.svg#state-waiting"></use>
                      </svg>
                    }
                    @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Active]) {
                      <svg [matTooltip]="'Aktiv'" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-available"></use></svg>
                    }
                    @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Inactive]) {
                      <svg [matTooltip]="'Inaktiv'" class="icon-24">
                        <use href="assets/images/ok-icons-sprite.svg#state-paused"></use>
                      </svg>
                    }
                    @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.NoIdTagGroup]) {
                      <svg [matTooltip]="'Adgang fjernet'" class="icon-24">
                        <use href="assets/images/ok-icons-sprite.svg#state-deactivated"></use>
                      </svg>
                    }
                    @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Blocked]) {
                      <svg [matTooltip]="'Spærret'" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-faulted"></use></svg>
                    }
                  </td>
                  <td>{{ idTag.printedId }}</td>
                  <td>{{ idTag.idToken }}</td>
                  <td>
                    <div class="flex">
                      <a
                        [routerLink]="['/id-tags']"
                        [queryParams]="idTagQueryParams(idTag)"
                        target="_new"
                        class="blue icon-with-text margin--left-auto">
                        <mat-icon class="material-icons">find_in_page</mat-icon>
                        <span>Se detaljer</span>
                      </a>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      }
      @if (accessGroups$ | async; as accessGroups) {
        <div class="accessgroup-header margin--top-m">
          <h3>Adgangsgrupper</h3>
          <div class="flex margin--left-auto">
            @if (cu && cu.previousAccessGroupCount !== 0) {
              <a
                (click)="openPreviousAccessGroups(cu)"
                class="blue pointer icon-with-text margin--right-m"
                title="Se tidligere adgangsgrupper">
                <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#users-s"></use></svg>
                <span>Tidligere adgangsgrupper</span>
              </a>
            }
          </div>
        </div>
        @if (accessGroups.length === 0) {
          <em>Der er ingen tilknyttede adgangsgrupper</em>
        }
        @if (accessGroupsMain.length > 0) {
          <table class="table table--center-vert">
            <thead>
              <tr>
                <th class="align-left" colspan="2">Navn</th>
                <th class="align-left time-limited">Tidsbegrænset</th>
                <th class="align-left">Rabat</th>
                <th class="details"></th>
              </tr>
            </thead>
            <tbody>
              @for (accessGroup of accessGroupsMain; track accessGroup.identifier) {
                <tr
                  valign="top"
                  [class.muted]="accessGroup.deleted"
                  [matTooltip]="accessGroup.deleted ? 'Adgangsgruppen slettet fra bruger d.' + (accessGroup.deleted | date: 'short') : ''">
                  <td colspan="2">{{ accessGroup.name }}</td>
                  <td>
                    @if (accessGroup.accessType === accessGroupUserType.TimeLimited) {
                      <div class="icon-with-text">
                        <mat-icon
                          class="cursor-help"
                          matTooltip="Brugeren har adgang fra {{ accessGroup.timeLimitedFrom | date: 'shortDate' }} til og med {{
                            accessGroup.timeLimitedTo | date: 'shortDate'
                          }}"
                          >update</mat-icon
                        >
                        {{ accessGroup.timeLimitedTo | date: 'shortDate' }}
                      </div>
                    }
                    @if (accessGroup.accessType === accessGroupUserType.Permanent) {
                      Nej
                    }
                  </td>
                  <td>
                    @if (accessGroup.discountType === discountType.FixedAmount) {
                      {{ accessGroup.amount | dkCurrency }}
                    } @else if (accessGroup.discountType === discountType.Percentages) {
                      {{ accessGroup.amount | number: '1.2-2' }}%
                    }
                  </td>
                  <td>
                    <div class="flex">
                      <a
                        [routerLink]="['/access-groups']"
                        [queryParams]="{ accessGroupIdentifier: accessGroup.identifier, filterName: accessGroup.name }"
                        target="_new"
                        class="blue icon-with-text margin--left-auto"
                        title="Se detaljer">
                        <mat-icon class="material-icons">find_in_page</mat-icon>
                        <span>Se detaljer</span>
                      </a>
                    </div>
                  </td>
                </tr>
              }
              @if (accessGroupsByDeviceId.length > 0) {
                <tr style="background-color: transparent">
                  <td colspan="5" class="align-left">
                    <h3 class="margin--top-m table-row-header" [matTooltip]="cu.deviceId">Adgangsgrupper gennem brugerens enheds-id</h3>
                  </td>
                </tr>
                <tr class="margin--top-m">
                  <th class="align-left">Navn</th>
                  <th class="align-left">Organisation</th>
                  <th class="align-left time-limited">Tidsbegrænset</th>
                  <th class="align-left discount">Rabat</th>
                  <th></th>
                </tr>
                @for (accessGroup of accessGroupsByDeviceId; track accessGroup) {
                  <tr valign="top">
                    <td>{{ accessGroup.name }}</td>
                    <td>{{ accessGroup.organizationName }}</td>
                    <td>
                      @if (accessGroup.accessType === accessGroupUserType.TimeLimited) {
                        <div class="icon-with-text">
                          <mat-icon
                            class="cursor-help"
                            matTooltip="Brugeren har adgang fra {{ accessGroup.timeLimitedFrom | date: 'shortDate' }} til og med {{
                              accessGroup.timeLimitedTo | date: 'shortDate'
                            }}"
                            >update</mat-icon
                          >
                          {{ accessGroup.timeLimitedTo | date: 'shortDate' }}
                        </div>
                      }
                      @if (accessGroup.accessType === accessGroupUserType.Permanent) {
                        Nej
                      }
                    </td>
                    <td>
                      @if (accessGroup.discountType === discountType.FixedAmount) {
                        {{ accessGroup.amount | dkCurrency }}
                      } @else if (accessGroup.discountType === discountType.Percentages) {
                        {{ accessGroup.amount | number: '1.2-2' }}%
                      }
                    </td>
                    <td>
                      <div class="flex">
                        <a
                          [routerLink]="['/access-groups']"
                          [queryParams]="{ accessGroupIdentifier: accessGroup.identifier, filterName: accessGroup.name }"
                          target="_new"
                          class="blue icon-with-text margin--left-auto"
                          title="Se detaljer">
                          <mat-icon class="material-icons">find_in_page</mat-icon>
                          <span>Se detaljer</span>
                        </a>
                      </div>
                    </td>
                  </tr>
                }
              }
              @if (accessGroupsByMokUserNumber.length > 0) {
                <tr style="background-color: transparent">
                  <td colspan="5" class="align-left">
                    <h3 class="margin--top-m table-row-header" [matTooltip]="cu.mokUserNumber?.toString()">
                      Adgangsgrupper tildelt via MOK brugernr.
                    </h3>
                  </td>
                </tr>
                <tr>
                  <th class="align-left">Navn</th>
                  <th class="align-left">Organisation</th>
                  <th class="align-left time-limited">Tidsbegrænset</th>
                  <th class="align-left discount">Rabat</th>
                  <th></th>
                </tr>
                @for (accessGroup of accessGroupsByMokUserNumber; track accessGroup) {
                  <tr valign="top">
                    <td>{{ accessGroup.name }}</td>
                    <td>{{ accessGroup.organizationName }}</td>
                    <td>
                      @if (accessGroup.accessType === accessGroupUserType.TimeLimited) {
                        <div class="icon-with-text">
                          <mat-icon
                            class="cursor-help"
                            matTooltip="Brugeren har adgang fra {{ accessGroup.timeLimitedFrom | date: 'shortDate' }} til og med {{
                              accessGroup.timeLimitedTo | date: 'shortDate'
                            }}"
                            >update</mat-icon
                          >
                          {{ accessGroup.timeLimitedTo | date: 'shortDate' }}
                        </div>
                      }
                      @if (accessGroup.accessType === accessGroupUserType.Permanent) {
                        Nej
                      }
                    </td>
                    <td>
                      @if (accessGroup.discountType === discountType.FixedAmount) {
                        {{ accessGroup.amount | dkCurrency }}
                      } @else if (accessGroup.discountType === discountType.Percentages) {
                        {{ accessGroup.amount | number: '1.2-2' }}%
                      }
                    </td>
                    <td>
                      <div class="flex">
                        <a
                          [routerLink]="['/access-groups']"
                          [queryParams]="{ accessGroupIdentifier: accessGroup.identifier, filterName: accessGroup.name }"
                          target="_new"
                          class="blue icon-with-text"
                          title="Se detaljer">
                          <mat-icon class="material-icons">find_in_page</mat-icon>
                          <span>Se detaljer</span>
                        </a>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        }
      }
    </div>
  </div>
}
